import type { ComponentProps, ReactNode } from 'react';
import { Plus } from '@ui/icons';
import { cn } from '@shared/lib';

export interface AddExpenseButtonProps extends ComponentProps<'button'> {
  /** Button label — pass the i18n string (e.g. `t.shell.addExpense`). */
  children?: ReactNode;
}

/**
 * "Add expense" call-to-action (Figma header button): a soft periwinkle pill with a green plus.
 * Pixel-matched and token-driven (`--color-add-expense-{bg,border,icon}`). The label is passed in
 * (via children) so callers own the i18n string — reuse it anywhere the action appears.
 */
export function AddExpenseButton({
  children,
  className,
  type = 'button',
  ...props
}: AddExpenseButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        'inline-flex h-10.25 cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-full border border-add-expense-border bg-add-expense-bg px-3.5 text-sm tracking-[-0.28px] text-fg-strong transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-bg disabled:pointer-events-none disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {children}
      <Plus aria-hidden className="size-3.5 text-add-expense-icon" strokeWidth={2.5} />
    </button>
  );
}
